import { useRoutes } from "react-router-dom";

// Routes
import MainRoutes from "./main-route";

export default function ThemeRoutes() {
  return useRoutes(MainRoutes);
}
